import api from "@src/api/api";
import ShowMoreButton from "@src/components/elements/input/ShowMoreButton";
import ContactMyFollowersItem from "@src/pages/contacts/my_followers/ContactMyFollowersItem";
import { User } from "@src/utils/user";
import { useInfiniteQuery } from "@tanstack/react-query";

type Response = {
  data: User[];
  current_page: number;
  total_pages: number;
};

type Props = {
  searchQuery: string;
};

const BlockedList = ({ searchQuery }: Props) => {
  const contacts = useInfiniteQuery<Response>(
    ["blocked", searchQuery],
    async ({ pageParam = 0 }) => {
      const { data } = await api.get(`/api/v1/me/blocked?page=${pageParam}&q=${searchQuery}`);
      return data;
    },
    {
      getNextPageParam: lastPage => {
        const nextPage = lastPage.current_page + 1;
        return nextPage <= lastPage.total_pages ? nextPage : false;
      },
    },
  );

  return (
    <>
      <div className="grid grid-cols-2 gap-4 md:grid-cols-3">
        {contacts.data &&
          contacts.data.pages.map(page =>
            page.data.map((item: User) => <ContactMyFollowersItem key={item.id} user={item} />),
          )}
      </div>
      {contacts.hasNextPage && !contacts.isFetchingNextPage && (
        <ShowMoreButton onClick={() => contacts.fetchNextPage()} />
      )}
    </>
  );
};

export default BlockedList;
